import { useTranslation } from "react-i18next";
import { Editor } from "@tiptap/react";
import { mdiFormatItalic } from "@mdi/js";
import { FormattingToggle } from "./FormattingToggle";

type Props = {
  editor: Editor;
};

export function ItalicFormattingToggle({ editor }: Props) {
  const { t } = useTranslation();

  return (
    <FormattingToggle
      icon={mdiFormatItalic}
      tooltip={t("ItalicFormattingToggle.tooltip")}
      pressed={editor.isActive("italic")}
      onPressedChange={() => editor.chain().focus().toggleItalic().run()}
    />
  );
}
